export default __webpack_public_path__ + "static/media/navbarlogo.ca29aa66.png";